const language = "japan";
export const langDir = "ltr";

export default language;
